import { ElMessage, ElMessageBox } from "element-plus";
import { h } from "vue";

import { createIntl, createIntlCache } from "@formatjs/intl";
import constant from "./constant.js";

import { data_department_tree, data_admin_select } from "@/http/data";

import store from "@/store";

const intl = createIntl(
  {
    locale: "zh-CN",
    messages: {},
  },
  createIntlCache(),
);

/**金额格式化 */
export const priceFormat = (num, n = 2) => {
  return intl.formatNumber(num, {
    minimumFractionDigits: n,
  });
};

export const numberFormat = (value) => {
  return priceFormat(value, 0);
};

/* 带提示框的通用请求接口函数
 * func：请求接口
 * id：数据Id
 * backFunc：回调
 * message：提示语
 */
export const confirm_func = (func, id, backFunc, message = "确认删除?") => {
  ElMessageBox.confirm(message, "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    dangerouslyUseHTMLString: true,
    type: "warning",
  }).then(() => {
    func(id).then((res) => {
      if (res.status == 200) {
        ElMessageBox.alert(res.data.msg, "提示", {
          dangerouslyUseHTMLString: true,
          type: "success",
          callback: () => {
            backFunc();
          },
        });
      } else {
        ElMessage({
          message: res.data.msg,
          type: "error",
        });
      }
    });
  });
};

//提交接口处理函数
export const post_response = (res, emit) => {
  if (res.status == 200) {
    ElMessage({
      message: res.data.msg,
      showClose: true,
      grouping: true,
      dangerouslyUseHTMLString: true,
      type: "success",
    });
    setTimeout(() => {
      emit("close", true);
    }, 500);
  }
};

//权限验证
export const judge_auth = (qxs) => {
  if (Array.isArray(qxs)) {
    return (
      store.state.loginUser?.is_super_auth == 1 ||
      store.state.loginUser?.codes?.some((w) => qxs.includes(w))
    );
  } else {
    return (
      store.state.loginUser?.is_super_auth == 1 ||
      store.state.loginUser?.codes?.includes(qxs)
    );
  }
};

//状态字段格式化，添加颜色
export const statusFormat = (item) => {
  return h("text", { style: "color:" + item?.Color }, item?.Text || "-");
};

/**
 * 状态格式化，返回vue的h对象
 * arr   数组名称（constant文件中配置的数组）
 * value 状态的值
 */
export const statusFormat2 = (arrName, value) => {
  const item = constant[arrName].find((w) => w.Key == value);
  if (item != null)
    return h("text", { style: "color:" + item?.Color }, item?.Text || "-");
  else return "";
};

//判断是否数字
export const judgeNumber = (value) => {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

//判断数字是否为空或0
export const numberIsNullOrZero = (value) => {
  return !value || value == 0;
};

//内容超过指定行数显示省略号  默认2行
export const showToolTip = (value, line = 2) => {
  return h("div", {
    innerHTML: value || "-",
    style:
      "display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: " +
      line +
      ";overflow: hidden;text-overflow: ellipsis;",
  });
};

//构建负责人级联选择框数据
export const admin_cascader = () => {
  const departmentFunc = new Promise((suc) => {
    data_department_tree().then((res) => {
      if (res.status == 200) suc(res.data.data);
    });
  });

  const adminFunc = new Promise((suc) => {
    data_admin_select().then((res) => {
      if (res.status == 200) suc(res.data.data?.list);
    });
  });

  return new Promise((suc) => {
    Promise.all([departmentFunc, adminFunc])
      .then((res) => {
        suc(build_admin_cascader(res[0], res[1]));
      })
      .catch(() => {
        suc([]);
      });
  });
};

const build_admin_cascader = (departmentArr, adminArr) => {
  let arr = [];
  departmentArr.forEach((e) => {
    let item = {
      id: "d_" + e.id,
      name: e.name,
      pid: e.pid,
      pname: e.pname,
      type: 0,
    };
    item.children = build_admin_cascader(e.children || [], adminArr);
    const admins = adminArr
      .filter((w) => w.department_id == e.id)
      .map((m) => {
        return {
          id: m.id,
          name: m.name,
          pid: m.department_id,
          pname: m.department_name,
          type: 1,
        };
      });
    if (admins.length > 0) {
      item.children = [...(item.children || []), ...admins];
      arr.push(item);
    }
  });
  return arr;
};

//复制
export const onCopy = (value) => {
  if (value == null || value == undefined) return false;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard 向剪贴板写文本
      navigator.clipboard.writeText(value);
    } else {
      // 创建text area
      let textArea = document.createElement("textarea");
      textArea.value = value;
      // 使text area不在viewport，同时设置不可见
      textArea.style.position = "absolute";
      textArea.style.opacity = 0;
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      textArea.remove();
    }
    ElMessage({
      type: "success",
      message: "已复制",
      grouping: true,
    });
  } catch (err) {
    ElMessage({
      type: "error",
      message: "复制失败",
      grouping: true,
    });
  }
};
